import { render, staticRenderFns } from "./ProcessDocumentCreateTab.vue?vue&type=template&id=d2c904da&scoped=true"
import script from "./ProcessDocumentCreateTab.vue?vue&type=script&lang=js"
export * from "./ProcessDocumentCreateTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c904da",
  null
  
)

export default component.exports